<template>
  <div>
    <p>{{text}}</p>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Hello world!"
    }
  },
  mounted () {
    this.$emit("loaded");
  }
};
</script>
<style>
</style>